var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(item,index){return _c('div',{key:index + '',class:[
			'zov-select-option',
			{
				'zov-select-option-selected':
					_vm.selectedValues.indexOf(item[_vm.valueName]) !== -1
			}
		],attrs:{"disabled":item.disabled},on:{"!click":function($event){$event.stopPropagation();return _vm.$emit('on-click', item)}}},[_vm._t("default",null,{"props":{ item: item, index: index }}),(_vm.selectedValues.indexOf(item[_vm.valueName]) !== -1)?_c('Icon',{attrs:{"zov-internal-reference-select":"","iconname":"checkmark"}}):_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }